import React from 'react';
import { connect } from 'react-redux';

import SignupButton from './SignupButton';

import { updateQueryString } from '../../redux/router/actions';

const SignupButtonConnected = (props) => <SignupButton {...props} />;

const mapActionsToProps = {
  updateQueryString,
};

export default connect(null, mapActionsToProps)(SignupButtonConnected);
